/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1BannerBanneridLangsId202,
  DeleteApiV1BannerBanneridLangsId401,
  DeleteApiV1BannerBanneridLangsId404,
  DeleteApiV1BannerBanneridLangsId500,
  DeleteApiV1BannerBanneridLangsIdMutationResponse,
  DeleteApiV1BannerBanneridLangsIdPathParams,
} from "../../types/bannerIdiomasController/DeleteApiV1BannerBanneridLangsId.ts";

export const deleteApiV1BannerBanneridLangsIdPathParamsSchema = z.object({
  bannerId: z.coerce.number().int(),
  id: z.coerce.number().int(),
}) as unknown as ToZod<DeleteApiV1BannerBanneridLangsIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const deleteApiV1BannerBanneridLangsId202Schema =
  z.any() as unknown as ToZod<DeleteApiV1BannerBanneridLangsId202>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1BannerBanneridLangsId401Schema =
  z.any() as unknown as ToZod<DeleteApiV1BannerBanneridLangsId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1BannerBanneridLangsId404Schema =
  z.any() as unknown as ToZod<DeleteApiV1BannerBanneridLangsId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1BannerBanneridLangsId500Schema =
  z.any() as unknown as ToZod<DeleteApiV1BannerBanneridLangsId500>;

export const deleteApiV1BannerBanneridLangsIdMutationResponseSchema = z.lazy(
  () => deleteApiV1BannerBanneridLangsId202Schema,
) as unknown as ToZod<DeleteApiV1BannerBanneridLangsIdMutationResponse>;
